module.exports = __webpack_public_path__ + "static/img/name.680370e8.png";